import React from "react";

const Logout = (props) => {
  const { handleClearUser } = props;
  handleClearUser();
  return (window.location = "/login");
};

export default Logout;
